import { NAMESPACE } from '../.';
import { ACTIONS } from './types';
export function setPlatformJourneys(payload) {
    return {
        type: `${NAMESPACE}/${ACTIONS.SET_PLATFORM_JOURNEY}`,
        payload,
    };
}
export function setIsSubscribedToNewsletter() {
    return setPlatformJourneys({ isEligibleForVoucher: false });
}
//# sourceMappingURL=actions.js.map